import api from "./api";

export async function fetchQuizAnswerSheet(params = {}) {
  const response = await api.get("/quiz/answer-sheet", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
